Librarian.Modules.OpenCat = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-opencat-",
        path: null,
        label: null,
        id: null,
        onClick: null,
        treeview: 0,
        showtree: false
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        // open category on click
        var self = this;

        // add click handler to module
        wrapperEl.addOnClick(function() {
            Librarian.Modules.OpenCat.openCategory(self.options.treeview, self.options.path, self.options.showtree);
        });

        this.parent(this.options, wrapperEl);

    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();
        this.wrapperEl.addClass("nav-wrapper");
      
        // add label
        var label = (this.options.label.toString() || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }
});

Librarian.Modules.OpenCat.extend({
    openCategory: function (treeViewType, path, showtree) {
        
        if (showtree) {
            console.log('open tree event triggered')
            Librarian.Init.toggleSideColumn(sideColumn, true, Librarian.treeView.openSidePanelOnPageClick);
        }

        if (treeViewType == 0) {
            Librarian.Utils.selectTreeNodeByPath(treeView, path, null, true);
        }

        else if (treeViewType == 1) {
            Librarian.Utils.selectTreeNodeByPath(gFavTreeView, path, null, true);
        }

        else if (treeViewType == 2) {
            Librarian.Utils.selectTreeNodeByPath(myFavTreeView, path, null, true);
        }
    }
})